import { action, makeObservable, observable } from 'mobx';
import { IMessageModal, IMessageModalProps } from '../types/messages';
import { arrayMerge } from 'src/utils/formatter';

export class MessagesStore {
  constructor() {
    makeObservable(this);
  }

  @observable public messages: IMessageModal[] = [];

  @action public addMessage(content: IMessageModalProps) {
    this.messages = arrayMerge(this.messages, [{ id: content.id || `${Date.now()}`, display: true, content }], 'id');
  }

  public removeMessage(id: string) {
    this.messages = this.messages.filter((message) => message.id !== id);
  }
}

export const messagesStore = new MessagesStore();
